module.exports = __webpack_public_path__ + "img/logo_zx.910af215.png";